<template>
  <div class="solid-geometry-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>V(柱) = Sh | V(锥) = ⅓Sh | S(球) = 4πr²$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="280" viewBox="0 0 500 280">
          <g transform="translate(250, 140)">
            <!-- Axis Helper (Optional) -->
            <line x1="-100" y1="0" x2="100" y2="0" stroke="rgba(255,255,255,0.05)" stroke-dasharray="2" />
            
            <!-- Sphere Mode -->
            <g v-if="mode === 'sphere'">
               <circle cx="0" cy="0" :r="80" fill="rgba(0, 210, 255, 0.1)" stroke="#00d2ff" stroke-width="2" />
               <ellipse cx="0" cy="0" rx="80" ry="25" fill="none" stroke="rgba(0, 210, 255, 0.3)" stroke-dasharray="4" />
               <line x1="0" y1="0" x2="80" y2="0" stroke="#ffd700" stroke-width="2" />
               <text x="40" y="-10" fill="#ffd700" font-size="12">r</text>
            </g>

            <!-- Cylinder Mode -->
            <g v-else-if="mode === 'cylinder'">
               <ellipse cx="0" y="-80" rx="60" ry="20" fill="none" stroke="#2ed573" stroke-width="2" />
               <ellipse cx="0" y="80" rx="60" ry="20" fill="rgba(46, 213, 115, 0.1)" stroke="#2ed573" stroke-width="2" />
               <line x1="-60" y1="-80" x2="-60" y2="80" stroke="#2ed573" stroke-width="2" />
               <line x1="60" y1="-80" x2="60" y2="80" stroke="#2ed573" stroke-width="2" />
               <line x1="0" y1="-80" x2="0" y2="80" stroke="rgba(255,255,255,0.3)" stroke-dasharray="5" />
               <text x="10" y="0" fill="#aaa" font-size="10">h</text>
            </g>

            <!-- Prism/Box Mode (3D projection) -->
            <g v-else-if="mode === 'prism'">
               <!-- Back face -->
               <rect x="-40" y="-50" width="80" height="100" fill="none" stroke="rgba(255,255,255,0.1)" stroke-dasharray="2" />
               <!-- Connecting lines -->
               <line x1="-40" y1="-50" x2="-70" y2="-20" stroke="#ff4757" stroke-dasharray="2" />
               <line x1="40" y1="-50" x2="10" y2="-20" stroke="#ff4757" />
               <line x1="40" y1="50" x2="10" y2="80" stroke="#ff4757" />
               <line x1="-40" y1="50" x2="-70" y2="80" stroke="#ff4757" />
               <!-- Front face -->
               <rect x="-70" y="-20" width="80" height="100" fill="rgba(255, 71, 87, 0.1)" stroke="#ff4757" stroke-width="2" />
            </g>
          </g>
        </svg>

        <div class="hud-top">
          <div class="stat">
            <label>图形类型: {{ modeDisplay }}</label>
          </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row items-center gap-4">
            <div class="flex-1">
               <label>选择几何体</label>
               <el-radio-group v-model="mode" size="mini">
                 <el-radio-button label="prism">长方体</el-radio-button>
                 <el-radio-button label="cylinder">圆柱体</el-radio-button>
                 <el-radio-button label="sphere">球体</el-radio-button>
               </el-radio-group>
            </div>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>立体几何：</strong>通过三维空间投影展示几何体的结构。关键在于理解其<strong>表面积（各个面之和）</strong>与<strong>体积（底面积乘以高或特定公式）</strong>的推导过程。投影法能有效帮助学生建立空间想象力。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SolidGeometryViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      mode: 'prism'
    }
  },
  computed: {
    modeDisplay() {
       const map = { prism: '长方体/棱柱', cylinder: '圆柱体', sphere: '球体' };
       return map[this.mode];
    }
  },
  mounted() {
    const kp = this.knowledgePoint;
    if (/球/.test(kp)) this.mode = 'sphere';
    else if (/柱|圆柱/.test(kp)) this.mode = 'cylinder';
    else if (/体|棱/.test(kp)) this.mode = 'prism';
  }
}
</script>

<style scoped lang="scss">
.solid-geometry-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #010205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; overflow-y: auto; }
.control-card { background: rgba(255,255,255,0.02); border-radius: 12px; padding: 15px; }
.discovery-note { background: rgba(46, 213, 115, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
.row { display: flex; gap: 20px; align-items: center; }
label { font-size: 0.75rem; color: #888; margin-bottom: 5px; display: block; }
.flex-1 { flex: 1; }
</style>
